import { render, staticRenderFns } from "./AppSection.vue?vue&type=template&id=1a0d9937&scoped=true"
import script from "./AppSection.vue?vue&type=script&lang=ts"
export * from "./AppSection.vue?vue&type=script&lang=ts"
import style0 from "./AppSection.vue?vue&type=style&index=0&id=1a0d9937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0d9937",
  null
  
)

export default component.exports